import request from "@/utils/request";

//获取用户信息
function user_info(params) {
  return request({
    url: "/api/app/user.php?action=userinfo&",
    method: "get",
    params,
  });
}

function send_captcha(params) {
  return request({
    url: "/api/app/brand.php?action=send_sms",
    method: "get",
    params,
  });
}

function login_mobile(params) {
  return request({
    url: "/api/app/brand.php?action=register_login",
    method: "get",
    params,
  });
}

export { user_info, send_captcha, login_mobile };
